module.exports = __webpack_public_path__ + "static/media/rnd.de2ccd30.jpg";